<template>
  <v-avatar :class="classes" :color="color" :size="size" :left="left">
    <v-icon v-if="icon" class="user-avatar__icon" small>{{ icon }}</v-icon>
    <span v-else class="white--text">{{ initials }}</span>
  </v-avatar>
</template>

<script>
export default {
  name: 'UserAvatar',
  props: {
    firstName: String,
    lastName: String,
    type: {
      type: String,
      description: 'user or group',
      default: 'user'
    },
    userEnabled: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number,
      description: 'Size of the avatar in pixels',
      default: 28
    },
    left: Boolean
  },
  computed: {
    isGroup() {
      return this.type.toLowerCase() === 'group'
    },
    isEmail() {
      return this.type.toLowerCase() === 'email'
    },
    initials() {
      if (this.isGroup || (!this.firstName && !this.lastName)) {
        return ''
      }
      let firstInitial = this.firstName ? this.firstName.charAt() : ''
      let lastInitial = this.lastName ? this.lastName.charAt() : ''
      return (firstInitial + lastInitial).toUpperCase()
    },
    color() {
      if (!this.userEnabled) return 'grey'

      if (this.isGroup) {
        return 'primary'
      }
      return 'accent'
    },
    icon() {
      if (this.isEmail) {
        return 'fa-envelope'
      } else if (this.isGroup) {
        return 'fa-users'
      } else if (!this.initials) {
        return 'fa-user'
      }
      return null
    },
    classes() {
      let classes = ['user-avatar']
      if (this.size >= 80) {
        classes.push('user-avatar-xx-large')
      }
      return classes
    }
  }
}
</script>
<style lang="scss" scoped>
.user-avatar {
  font-size: 0.875rem;
  user-select: none;
}
.user-avatar.user-avatar-xx-large {
  font-size: xx-large;
}
.user-avatar__icon {
  color: white !important;
}
</style>
